// @ts-nocheck
import React from 'react';
import { ApplyPluginsType, dynamic } from '/tmp/build/src/node_modules/@umijs/runtime';
import * as umiExports from './umiExports';
import { plugin } from './plugin';
import LoadingComponent from '@/Loading';

export function getRoutes() {
  const routes = [
  {
    "path": "/",
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'layout' */'/tmp/build/src/packages/onejsProject/src/layout'), loading: LoadingComponent}),
    "routes": [
      {
        "path": "/certification",
        "routes": [
          {
            "path": "/certification",
            "redirect": "/certification/colleague-assist",
            "exact": true
          },
          {
            "path": "/certification/colleague-assist",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__colleagueAssist' */'/tmp/build/src/packages/onejsProject/src/pages/colleagueAssist'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "path": "/certification/colleague-assist-overdue",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__colleagueAssistOverdue' */'/tmp/build/src/packages/onejsProject/src/pages/colleagueAssistOverdue'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "path": "/certification/colleague-assist-expired",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__colleagueAssistExpired' */'/tmp/build/src/packages/onejsProject/src/pages/colleagueAssistExpired'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "path": "/certification/colleague-assist-reject",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__colleagueAssistReject' */'/tmp/build/src/packages/onejsProject/src/pages/colleagueAssistReject'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "path": "/certification/colleague-assist-pass",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__colleagueAssistPass' */'/tmp/build/src/packages/onejsProject/src/pages/colleagueAssistPass'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "path": "/certification/identity-audit",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__identityAudit' */'/tmp/build/src/packages/onejsProject/src/pages/identityAudit'), loading: LoadingComponent}),
            "cid": "c_oa_4i41gxjy",
            "exact": true
          },
          {
            "path": "/certification/identity-reject",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__identityReject' */'/tmp/build/src/packages/onejsProject/src/pages/identityReject'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "path": "/certification/identity-pass",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__identityPass' */'/tmp/build/src/packages/onejsProject/src/pages/identityPass'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "path": "/certification/identity-expired",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__identityExpired' */'/tmp/build/src/packages/onejsProject/src/pages/identityExpired'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "path": "/certification/feedback",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__feedback' */'/tmp/build/src/packages/onejsProject/src/pages/feedback'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "path": "/certification/real-name/callback",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__realName__callback' */'/tmp/build/src/packages/onejsProject/src/pages/realName/callback'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "path": "/certification/meeting-passkey",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__meetingroomPasskey' */'/tmp/build/src/packages/onejsProject/src/pages/meetingroomPasskey'), loading: LoadingComponent}),
            "exact": true
          }
        ]
      },
      {
        "path": "/intercept",
        "routes": [
          {
            "path": "/intercept/distrust",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__distrust' */'/tmp/build/src/packages/onejsProject/src/pages/distrust'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "path": "/intercept/help",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__help' */'/tmp/build/src/packages/onejsProject/src/pages/help'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "path": "/intercept/todo",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__todo' */'/tmp/build/src/packages/onejsProject/src/pages/todo'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "path": "/intercept/login/feedback",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__loginFeedback' */'/tmp/build/src/packages/onejsProject/src/pages/loginFeedback'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "path": "/intercept/dx/download",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__dxDownload' */'/tmp/build/src/packages/onejsProject/src/pages/dxDownload'), loading: LoadingComponent}),
            "exact": true
          }
        ]
      },
      {
        "path": "/dc/pass/forget",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__forgetPassword' */'/tmp/build/src/packages/onejsProject/src/pages/forgetPassword'), loading: LoadingComponent}),
        "routes": [
          {
            "path": "/dc/pass/forget",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__forgetPassword__redirect' */'/tmp/build/src/packages/onejsProject/src/pages/forgetPassword/redirect'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "path": "/dc/pass/forget/verify-mobile",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__forgetPassword__verifyMobile' */'/tmp/build/src/packages/onejsProject/src/pages/forgetPassword/verifyMobile'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "path": "/dc/pass/forget/verify-code",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__forgetPassword__verifyCode' */'/tmp/build/src/packages/onejsProject/src/pages/forgetPassword/verifyCode'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "path": "/dc/pass/forget/verify-email",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__forgetPassword__verifyEmail' */'/tmp/build/src/packages/onejsProject/src/pages/forgetPassword/verifyEmail'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "path": "/dc/pass/forget/verify-email-code",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__forgetPassword__verifyEmailCode' */'/tmp/build/src/packages/onejsProject/src/pages/forgetPassword/verifyEmailCode'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "path": "/dc/pass/forget/account-list",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__forgetPassword__accountList' */'/tmp/build/src/packages/onejsProject/src/pages/forgetPassword/accountList'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "path": "/dc/pass/forget/reset-pwd",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__forgetPassword__resetPwd' */'/tmp/build/src/packages/onejsProject/src/pages/forgetPassword/resetPwd'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "path": "/dc/pass/forget/success",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__forgetPassword__success' */'/tmp/build/src/packages/onejsProject/src/pages/forgetPassword/success'), loading: LoadingComponent}),
            "exact": true
          }
        ]
      },
      {
        "path": "/ssofe",
        "routes": [
          {
            "path": "/ssofe/face",
            "routes": [
              {
                "path": "/ssofe/face/middle",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__faceMiddle' */'/tmp/build/src/packages/onejsProject/src/pages/faceMiddle'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "path": "/ssofe/face/result",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__faceResult' */'/tmp/build/src/packages/onejsProject/src/pages/faceResult'), loading: LoadingComponent}),
                "exact": true
              }
            ]
          },
          {
            "path": "/ssofe/req-auth",
            "routes": [
              {
                "path": "/ssofe/req-auth/list",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__reqAuth__list' */'/tmp/build/src/packages/onejsProject/src/pages/reqAuth/list'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "path": "/ssofe/req-auth/sms-code",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__reqAuth__smsCode' */'/tmp/build/src/packages/onejsProject/src/pages/reqAuth/smsCode'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "path": "/ssofe/req-auth/passkey",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__reqAuth__passkey' */'/tmp/build/src/packages/onejsProject/src/pages/reqAuth/passkey'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "path": "/ssofe/req-auth/result",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__reqAuth__result' */'/tmp/build/src/packages/onejsProject/src/pages/reqAuth/result'), loading: LoadingComponent}),
                "exact": true
              }
            ]
          },
          {
            "path": "/ssofe/activate-account",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__activateAccount' */'/tmp/build/src/packages/onejsProject/src/pages/activateAccount'), loading: LoadingComponent}),
            "exact": true
          }
        ]
      }
    ]
  }
];

  // allow user to extend routes
  plugin.applyPlugins({
    key: 'patchRoutes',
    type: ApplyPluginsType.event,
    args: { routes },
  });

  return routes;
}
